var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEaseBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19157_8183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19157_8183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 25.5V28.5H30V25.5H6ZM10.5 9V6C10.5 5.175 10.794 4.4685 11.382 3.8805C11.969 3.2935 12.675 3 13.5 3H22.5C23.325 3 24.0315 3.2935 24.6195 3.8805C25.2065 4.4685 25.5 5.175 25.5 6V9H30C30.825 9 31.5315 9.294 32.1195 9.882C32.7065 10.469 33 11.175 33 12V28.5C33 29.325 32.7065 30.0315 32.1195 30.6195C31.5315 31.2065 30.825 31.5 30 31.5H6C5.175 31.5 4.469 31.2065 3.882 30.6195C3.294 30.0315 3 29.325 3 28.5V12C3 11.175 3.294 10.469 3.882 9.882C4.469 9.294 5.175 9 6 9H10.5ZM6 21H30V12H25.5V13.5375C25.5 13.9625 25.356 14.3125 25.068 14.5875C24.781 14.8625 24.425 15 24 15C23.575 15 23.219 14.856 22.932 14.568C22.644 14.281 22.5 13.925 22.5 13.5V12H13.5V13.5375C13.5 13.9625 13.3565 14.3125 13.0695 14.5875C12.7815 14.8625 12.425 15 12 15C11.575 15 11.2185 14.856 10.9305 14.568C10.6435 14.281 10.5 13.925 10.5 13.5V12H6V21ZM13.5 9H22.5V6H13.5V9Z",
    fill: "#D22730"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21H30V25.5H6V21Z",
    fill: "#5575C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEaseBusiness);
export default __webpack_public_path__ + "static/media/easeBusiness.bb293bb60d33142d63308b8ef8e702f0.svg";
export { ForwardRef as ReactComponent };